import { render, staticRenderFns } from "./TrasladoGestacion.vue?vue&type=template&id=e6b65078"
import script from "./TrasladoGestacion.vue?vue&type=script&lang=js"
export * from "./TrasladoGestacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports